import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/channel', // 频道专区
    name: 'Channel',
    meta: {
      title: '频道专区',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/channel/index.vue'),
  },
  {
    path: '/upstairsChannel', // 二楼品牌专区-推荐
    name: 'UpstairsChannel',
    meta: {
      title: '推荐',
      isApp: true,
      auth: false,
      isNeedTopBar: true,
      reportLogPageName: '二楼品牌专区',
    },
    component: () => import('@/views/channel/index.vue'),
  },
]

export default routes
